/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Strategia di calcolo del contributo erogato
 */
export enum TipoCalcoloContributo {

    ISEE = 'ISEE',

    COMPONENTI = 'COMPONENTI',

    PUNTEGGIO = 'PUNTEGGIO',

    ASSEGNAZIONE_SCOLASTICA = 'ASSEGNAZIONE_SCOLASTICA'
}

